import React, { useState, useEffect, useCallback } from 'react'
import PropTypes from 'prop-types'
import update from 'react-addons-update'
import { SelectInput } from '../Inputs/Inputs'

import AppDispatcher from '../../../dispatchers/AppDispatcher'

import styles from '../../../../css/settings.module.css'

const Application = (props) => {
  const { device, setting } = props

  // Return early if device is not available
  if (!device) {
    return null
  }

  // Safely extract application settings with proper defaults
  const applicationSettings = device?.application_settings || { settings: {} }
  const applicationSettingsNew = device?.application_settings_new || { settings: {} }
  const settingsObj = applicationSettings.settings || {}
  const settingsNewObj = applicationSettingsNew.settings || {}

  const [state, setState] = useState({
    original: settingsObj[setting],
    application: settingsNewObj[setting] !== undefined
      ? settingsNewObj[setting]
      : settingsObj[setting],
  })

  // Update state when device or setting changes
  useEffect(() => {
    if (!device) return

    const currentApplicationSettings = device?.application_settings || { settings: {} }
    const currentApplicationSettingsNew = device?.application_settings_new || { settings: {} }
    const currentSettingsObj = currentApplicationSettings.settings || {}
    const currentSettingsNewObj = currentApplicationSettingsNew.settings || {}

    const newOriginal = currentSettingsObj[setting]
    const newApplication = currentSettingsNewObj[setting] !== undefined
      ? currentSettingsNewObj[setting]
      : currentSettingsObj[setting]

    setState(prevState => {
      // Only update if values actually changed
      if (prevState.original === newOriginal && prevState.application === newApplication) {
        return prevState
      }
      return {
        original: newOriginal,
        application: newApplication,
      }
    })
  }, [device, setting])

  const appDispatch = useCallback((nextApplication = state.application) => {
    if (!device) return

    const { setting } = props
    const address = device?.address

    if (!address) return

    AppDispatcher.dispatch({
      action: 'change-setting',
      setting: {
        address,
        status: 'new',
        settings: {
          [setting]: nextApplication,
        },
      },
    })
  }, [device, props.setting, state.application])

  useEffect(() => {
    appDispatch()
  }, [appDispatch])

  const handleChange = useCallback((field, value, callback) => {
    const nextValue = Number(value)
    const newState = update(
      state,
      {
        [field]: { $set: nextValue },
      }
    )
    setState(newState)
    appDispatch(nextValue)
    if (callback) callback()
  }, [state, appDispatch])

  const childChange = useCallback((event) => {
    handleChange(event.target.name, event.target.value)
  }, [handleChange])

  const deviceType = device?.physical?.deviceType || ''
  const unit = ''
  const { application } = state

  let name = 'Application'
  let updateSelect = [
    {
      value: 0,
      name: 'Unknown',
    },
  ]
  switch (deviceType) {
    case 'pump':
      name = 'Pump Application'
      updateSelect = [
        {
          value: 0,
          name: 'None',
        },
        {
          value: 1,
          name: 'Schedule',
        },
      ]
      break
    case 'windMachine':
      /*

      from the firmware controller_factory.h
        ORCHARD_RITE = 0,
        ELECTRIC = 1,
        FROST_BOSS = 2,
        MPC20 = 3,
        EMS_PRO_LITE = 4,

      */
      name = 'Application'
      updateSelect = [
        {
          value: 0,
          name: 'Call to Start',
        },
        {
          value: 3,
          name: 'Murphy MPC-20',
        },
        {
          value: 1,
          name: 'Electric',
        },
        {
          value: 2,
          name: 'Frost Boss',
        },
        {
          value: 4,
          name: 'Murphy EMS Pro Lite',
        },
        {
          value: 5,
          name: 'Hauff PV-101',
        },
        {
          value: 6,
          name: 'Dynagen',
        },
        {
          value: 7,
          name: 'MPC-10',
        },
      ]
      break
    case 'temperature':
    case 'valve':
      name = 'Application'
      updateSelect = [
        {
          value: 0,
          name: 'Default',
        },
        {
          value: 1,
          name: 'Davis Weather',
        },
      ]
      break
    default:
  }

  return (
    <div className={styles.inputArea}>
      <section>
        <h5>
          {name}
        </h5>
        <div className={styles.applicationSelect}>
          <SelectInput
            value={application}
            options={updateSelect}
            childChange={childChange}
            field='application'
            style={styles.autostartSelectInput}
          />
          {unit}
        </div>
      </section>
    </div>
  )
}

Application.propTypes = {
  device: PropTypes.object.isRequired,
  setting: PropTypes.string.isRequired,
}

export default Application
